import {
  PAYMENT_METHOD_CAPITALIST_NAME,
  PAYMENT_METHOD_CARD_NAME,
  PAYMENT_METHOD_CLOUDPAY_NAME,
  PAYMENT_METHOD_CRYPTO_NAME,
  PAYMENT_METHOD_STRIPE,
  PAYMENT_METHOD_UNLIMINT_NAME,
  PAYMENT_METHOD_USDT_NAME,
  PAYMENT_METHOD_WALLET_NAME
} from '@/constants/plans'

export const setProviderByPaymentMethod = (state, data) => {
  switch (state.paymentInfo.paymentMethod) {
    case PAYMENT_METHOD_CARD_NAME:
      data.provider = PAYMENT_METHOD_CLOUDPAY_NAME
      break;
    case PAYMENT_METHOD_USDT_NAME:
      data.provider = state.invoice.provider
      data.coin = state.invoice.coin
      break;
    case PAYMENT_METHOD_CRYPTO_NAME:
      data.provider = state.invoice.provider
      data.coin = state.invoice.coin
      break;
    case PAYMENT_METHOD_WALLET_NAME:
      data.provider = state.invoice.provider

      if (state.invoice.coin) {
        data.coin = state.invoice.coin
      }
      break;
    case PAYMENT_METHOD_CAPITALIST_NAME:
      data.provider = PAYMENT_METHOD_CAPITALIST_NAME
      break;
    case PAYMENT_METHOD_UNLIMINT_NAME:
      data.provider = PAYMENT_METHOD_UNLIMINT_NAME
      break;
    case PAYMENT_METHOD_STRIPE:
      data.provider = PAYMENT_METHOD_STRIPE
      break;
  }

  return data
}
